import { Button } from '@chakra-ui/button';
import { Input } from '@chakra-ui/input';
import { Text } from '@chakra-ui/layout';
import { Progress } from '@chakra-ui/progress';
import { useToast } from '@chakra-ui/toast';
import firebase from 'firebase';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { PageContainer } from '../../../components/container/PageContainer';
import { isInDevelopment } from '../../../utils/detectEnv';

const getVimeoLink = (formData: FormData) => {
  if (formData.file_data && formData.file_data[0]) {
    const extension =
      formData.file_data[0].name.split('.').pop()?.toUpperCase() || '';
    if (!['MP4', 'MOV', 'WMV', 'AVI', 'FLV'].includes(extension)) {
      return { error: 'no-supported-file', data: null };
    }
    return firebase
      .app()
      .functions(isInDevelopment ? undefined : 'europe-west3')
      .httpsCallable('vimeoUploadLink')({
        size: formData.file_data[0].size,
      })
      .then((data) => data);
  }
  return { data: null, error: 'no-file' };
};

interface FormData {
  file_data?: File[];
}

interface AdminVideoUploadPageProps {}

export const AdminVideoUploadPage: React.FC<AdminVideoUploadPageProps> =
  ({}) => {
    const form = useForm<FormData>();
    const [loading, setLoading] = useState(false);
    const [progress, setProgress] = useState(0);

    const toast = useToast();

    return (
      <PageContainer>
        <Button
          type="button"
          isLoading={loading}
          onClick={async () => {
            setLoading(true);

            const formData = form.getValues();
            const link = await getVimeoLink(formData);

            if (link && link.data === null) {
              toast({ title: 'no supported file' });
            }
            if (link?.data && formData.file_data) {
              const xhr = new XMLHttpRequest();
              xhr.open('PATCH', link.data);
              xhr.setRequestHeader('Tus-Resumable', '1.0.0');
              xhr.setRequestHeader('Upload-Offset', '0');
              xhr.setRequestHeader(
                'Content-Type',
                'application/offset+octet-stream'
              );
              xhr.setRequestHeader(
                'Accept',
                'application/vnd.vimeo.*+json;version=3.4'
              );
              xhr.upload.addEventListener(
                'progress',
                (evt) => {
                  if (evt.lengthComputable) {
                    setProgress((evt.loaded / evt.total) * 100);
                  }
                },
                false
              );
              xhr.onloadstart = function (e) {
                console.log('start');
              };
              xhr.onloadend = function (e) {
                console.log(e);
              };
              xhr.send(formData.file_data[0]);
            }
          }}
        >
          Click
        </Button>
        <Text>{progress}</Text>
        <form>
          <Input type="file" {...form.register('file_data')} />
        </form>
        <Progress value={progress} />
      </PageContainer>
    );
  };
